module.exports = __webpack_public_path__ + "src/img/index_menu/blue/8.png?c4e1685f1099e6f4794274c52c92f665";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/blue/8.png
// module id = 190
// module chunks = 0